<template>
    <div>
        <!-- Page Hero -->
        <section class="page-hero d-flex align-items-center justify-content-center text-center text-white position-relative"
            style="background-color: #333; height: 400px; overflow: hidden;">
            <img src="https://placehold.co/1920x400/333333/666666?text=Cart"
                class="position-absolute w-100 h-100 object-fit-cover opacity-50" alt="Hero">
            <div class="position-relative z-1 mt-5">
                <h1 class="display-4 fw-bold font-serif mb-2">Cart</h1>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb justify-content-center mb-0">
                        <li class="breadcrumb-item"><a href="/"
                                class="text-white text-decoration-none small">Home</a></li>
                        <li class="breadcrumb-item active text-white-50 small" aria-current="page">Cart</li>
                    </ol>
                </nav>
            </div>
        </section>
        <div class="position-relative">
            <div class="torn-paper-edge"></div>
        </div>

        <!-- Main Content -->
        <section class="py-5 bg-light-creme">
            <div class="container mb-5">
                <!-- Stepper -->
                <div class="d-flex justify-content-center align-items-center mb-5 gap-3 stepper">
                    <div class="d-flex align-items-center gap-2 fw-bold text-brown">
                        <div class="rounded-circle bg-brown text-white d-flex align-items-center justify-content-center"
                            style="width: 30px; height: 30px;">1</div>
                        <span>Cart</span>
                    </div>
                    <div class="bg-secondary opacity-25" style="width: 100px; height: 1px;"></div>
                    <div class="d-flex align-items-center gap-2 text-muted">
                        <div class="rounded-circle border border-secondary d-flex align-items-center justify-content-center"
                            style="width: 30px; height: 30px;">2</div>
                        <span>Check Out</span>
                        <!-- <div class="bg-secondary rounded-circle ms-2 p-1" style="width: 8px; height: 8px;"></div> -->
                    </div>
                    <div class="bg-secondary opacity-25" style="width: 100px; height: 1px;"></div>
                    <div class="d-flex align-items-center gap-2 text-muted">
                        <div class="rounded-circle border border-secondary d-flex align-items-center justify-content-center"
                            style="width: 30px; height: 30px;">3</div>
                        <span>Payment</span>
                    </div>
                </div>

                <div class="bg-white rounded-4 shadow-sm p-4 p-md-5" v-if="loading">
                     <div class="text-center py-5">
                        <div class="spinner-border text-brown" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

                <div class="bg-white rounded-4 shadow-sm p-4 p-md-5" v-else-if="cart && cart.cart_items && cart.cart_items.length > 0">
                    <div class="row g-5">
                        <!-- Products Column -->
                        <div class="col-lg-7 border-end-lg">
                            <h5 class="fw-bold mb-4 font-serif">Products</h5>

                            <div class="d-flex align-items-start justify-content-between mb-4 pb-4 border-bottom" v-for="item in cart.cart_items" :key="item.id">
                                <div class="d-flex gap-3">
                                    <div class="bg-light-creme rounded-3 overflow-hidden" style="width: 100px; height: 100px;">
                                        <img :src="item.default_image.medium"
                                            class="img-fluid w-100 h-100 object-fit-cover" :alt="item.name">
                                    </div>
                                    <div>
                                        <h6 class="fw-bold mb-1">{{ item.name }}</h6>
                                        <!-- <p class="small text-muted mb-3">Color: <span class="text-dark">Gunnared beige</span></p> -->
                                        <div class="input-group input-group-sm mt-3" style="width: 100px;">
                                            <button class="btn btn-outline-secondary" type="button" @click="updateQuantity(item, 'decrease')">-</button>
                                            <input type="text"
                                                class="form-control text-center border-secondary bg-transparent" :value="item.quantity" readonly>
                                            <button class="btn btn-outline-secondary" type="button" @click="updateQuantity(item, 'increase')">+</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-end d-flex flex-column justify-content-between h-100"
                                    style="min-height: 100px;">
                                    <div class="fw-bold text-brown">EGP {{ item.price }}</div>
                                    <button class="btn btn-link text-muted p-0 text-decoration-none" @click="removeItem(item)"><i
                                            class="bi bi-trash"></i></button>
                                </div>
                            </div>

                        </div>

                        <!-- Order Summary Column -->
                        <div class="col-lg-5 ps-lg-5">
                            <h5 class="fw-bold mb-4 font-serif">Order Summary</h5>

                            <div class="d-flex justify-content-between mb-2 small">
                                <span class="text-muted">Price</span>
                                <span class="fw-bold">EGP {{ cart.total }}</span>
                            </div>
                            <!-- 
                            <div class="d-flex justify-content-between mb-2 small">
                                <span class="text-muted">Discount</span>
                                <span class="fw-bold">-EGP 10.00</span>
                            </div> 
                            -->
                            <div class="d-flex justify-content-between mb-4 small">
                                <span class="text-muted">Shipping</span>
                                <span class="fw-bold text-success">Free</span>
                            </div>

                            <div class="border-top border-bottom py-3 mb-4">
                                <div class="d-flex justify-content-between align-items-center">
                                    <span class="fw-bold">Total</span>
                                    <span class="fw-bold fs-5">EGP {{ cart.total }}</span>
                                </div>
                            </div>

                            <a href="/checkout" class="btn btn-brown w-100 py-2 rounded-1 mb-3">Proceed To Checkout</a>
                        </div>
                    </div>
                </div>
                
                 <div class="bg-white rounded-4 shadow-sm p-5 text-center" v-else>
                    <h3 class="fw-bold text-muted mb-4">Your cart is empty</h3>
                    <a href="/products" class="btn btn-brown rounded-pill px-4">Continue Shopping</a>
                </div>

            </div>
        </section>

        <!-- Footer -->
        <footer-section :logo="logo"></footer-section>
    </div>
</template>

<script>
    export default {
        props: {
             logo: {
                type: String,
                default: null
            },
        },
        data() {
            return {
                cart: null,
                loading: true
            }
        },
        mounted() {
            this.fetchCart();
        },
        methods: {
            fetchCart() {
                this.loading = true;
                axios.get('/api/frontend/cart')
                    .then(response => {
                        const carts = response.data.data;
                        if (Array.isArray(carts) && carts.length > 0) {
                             this.cart = carts[0];
                        } else {
                            this.cart = null;
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching cart:', error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            updateQuantity(item, action) {
                const endpoint = action === 'increase' ? '/api/frontend/cart/add-quantity' : '/api/frontend/cart/decrease-quantity';
                let newQuantity = item.quantity;

                if (action === 'increase') {
                    newQuantity += 1;
                } else if (action === 'decrease') {
                    newQuantity -= 1;
                }

                if (newQuantity < 1 && action === 'increase') return; 
                // If decrease and 0, backend might remove (decreaseQuantity logic)
                
                axios.post(endpoint, {
                    product_id: item.id,
                    quantity: newQuantity
                })
                .then(response => {
                     this.cart = response.data.data;
                     this.updateNavbar(this.cart);
                })
                .catch(error => {
                     console.error('Error updating quantity:', error);
                });
            },
            removeItem(item) {
                 axios.post('/api/frontend/cart/remove', {
                    product_id: item.id
                })
                .then(response => {
                     this.cart = response.data.data;
                     this.updateNavbar(this.cart);
                })
                .catch(error => {
                     console.error('Error removing item:', error);
                });
            },
            updateNavbar(cart) {
                 let count = 0;
                if(cart && cart.cart_items) {
                     count = cart.cart_items.length;
                }
                window.Bus.$emit('cart-updated', count);
            }
        }
    }
</script>
